export default "__VITE_ASSET__B8TrbvK2__"